import { ref } from 'vue';

const defaultColor = '#f37c82';
const isDefaultColor = ref(true);
const primaryColor = ref('');
const secondaryColor = ref('');
const playerPrimaryColor = ref('');
const playerSecondaryColor = ref('');
const playerSecondaryHoverColor = ref('');

export default function useBackgroundColor() {
  function getDarkestColors(palette) {
    const defaultColors = {
      primary: '',
      secondary: '',
    };

    if (!palette) return defaultColors;

    isDefaultColor.value = false;

    const swatches = Object.values(palette).filter(
      (swatch) => swatch?.rgb && swatch?.population,
    );

    if (swatches.length === 0) return null;

    const darkestSwatch = swatches.reduce((darkest, current) =>
      getBrightness(current.rgb) < getBrightness(darkest.rgb)
        ? current
        : darkest,
    );

    return {
      primary: rgbToString(darkestSwatch.rgb),
      primaryDarker: darkenRgb(darkestSwatch.rgb, 0.45),
      secondary: lightenRgb(darkestSwatch.rgb, 0.15),
      hover: lightenRgb(darkestSwatch.rgb, 0.45),
    };
  }

  function getLightColor(palette) {
    if (!palette) return null;

    const swatches = ['LightMuted', 'LightVibrant']
      .map((key) => palette[key])
      .filter((swatch) => swatch?.rgb);

    if (swatches.length === 0) return null;

    const mostDominantSwatch = swatches.reduce((a, b) =>
      a.population > b.population ? a : b,
    );

    return rgbToString(mostDominantSwatch.rgb);
  }

  const getBrightness = ([r, g, b]) => 0.299 * r + 0.587 * g + 0.114 * b;

  function lightenRgb([r, g, b], percentage) {
    const lighten = (channel) =>
      Math.min(255, Math.round(channel + (255 - channel) * percentage));
    return rgbToString([lighten(r), lighten(g), lighten(b)]);
  }

  function darkenRgb([r, g, b], percentage) {
    const darken = (channel) =>
      Math.max(0, Math.round(channel * (1 - percentage)));
    return rgbToString([darken(r), darken(g), darken(b)]);
  }

  const rgbToString = (rgbArray) =>
    `rgb(${rgbArray.map(Math.round).join(', ')})`;

  function resetPlayerSecondaryColors() {
    isDefaultColor.value = true;
    playerSecondaryColor.value = '';
    playerSecondaryHoverColor.value = '';
  }

  return {
    defaultColor,
    isDefaultColor,
    primaryColor,
    secondaryColor,
    playerPrimaryColor,
    playerSecondaryColor,
    playerSecondaryHoverColor,
    getDarkestColors,
    getLightColor,
    getBrightness,
    lightenRgb,
    resetPlayerSecondaryColors,
  };
}
